module.exports = __webpack_public_path__ + "img/attendance_summary.07f62b51.svg";